<template>
  <rmr-soft-badge
    :label="config.label"
    :color="config.color"
    :background="config.background"
    :title="`Provenance : ${config.label}`"
    size="xs"
  />
</template>

<script>
import { computed } from "@vue/composition-api";

import RmrSoftBadge from "@/components/ui/feedback/RmrSoftBadge.vue";

import { PROVENANCES } from "../constants";

export default {
  name: "CtcProvenanceBadge",
  components: { RmrSoftBadge },
  props: {
    source: {
      type: String,
      required: true,
      validator: (value) => Object.keys(PROVENANCES).includes(value),
    },
  },
  setup(props) {
    return {
      config: computed(() => PROVENANCES[props.source]),
    };
  },
};
</script>
